<template>

    <div class="flex w-full flex-col p-6 sm:p-10 xl:p-12 text-lg sm:text-xl xl:text-xl 2.5xl:text-1.5xl text-secondary-400 bg-white/5 transition-all" v-if="discount == 0" :class="!showDiscountBox &&  '!py-6 !sm:py-8'">
        <div class="relative flex flex-col w-full">

            <div class="relative flex w-full cursor-pointer" @click="showDiscountBox = !showDiscountBox">
                <div class="flex-grow">
                    <h4 class="text-white text-lg tracking-[0.05em] uppercase">
                        {{$root.translateString('have_code')}}
                    </h4>
                </div>
                <div class="flex items-center justify-end">
                    <img alt="icona" src="/images/svg/icon-caret.svg" width="10" height="7" class="w-3 h-auto transition-all" :class="showDiscountBox && 'rotate-180'" />
                </div>
            </div>

            <div class="relative flex flex-col w-full" v-if="showDiscountBox">

                <div class="relative w-full pt-6">

                    <div class="relative w-full">
                        <input @focus="validation.discount.state = null" class="pb-2 px-0 border-b border-white/50 bg-transparent outline-none h-[41px] text-white text-1.5xl peer w-full" placeholder=" " type="text" v-model="discountCode" />
                        <label class="text-white text-xs absolute left-1/2 -translate-x-1/2 -top-4 !tracking-[0.01em] font-light opacity-50 pointer-events-none peer-focus:!text-xs peer-focus:-top-4 peer-placeholder-shown:text-[18px] peer-placeholder-shown:sm:text-[19px] peer-placeholder-shown:md:text-[20px] peer-placeholder-shown:lg:text-[21px] peer-placeholder-shown:xl:text-[22px] peer-placeholder-shown:2xl:text-[23px] peer-placeholder-shown:top-0 transition-all">{{ $root.translateString('discount_code') }}</label>
                    </div>

                </div>

                <span v-if="validation.discount.state != null" class="text-red-400 px-1.5 text-xxs uppercase flex items-center mt-2">
                    {{ validation.discount.message }}
                </span>

                <!-- <div class="pt-1 full-input">
                    <div class="mt-2 full-input__field-gr">
                        <input type="text" @focus="validation.discount.state = false" v-model="discountCode" :placeholder="$root.translateString('discount_code')" >
                        <label class="full-input__after-input focused">{{$root.translateString('code')}}</label>
                        <div class="invalid-feedback" :class="{'d-block' : validation.discount.state}">{{validation.discount.message}}</div>
                    </div>
                </div> -->

                <div class="mt-8 mb-2 form-submit">
                    <button @click="applyDiscount" type="button" class="relative inline-flex border default-btn border-primary-300 group flex-grow w-full text-center xl:max-w-[340px] 2xl:max-w-[386px] hover:bg-primary-400/10 transition-all">
                        <span class="block w-full pt-2.5 pb-3 px-15 text-primary-300 text-[18px] md:text-[19px] xl:text-[20px]">
                            {{$root.translateString('apply_code')}}
                        </span>
                        <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:left-6 transition-all"></span>
                        <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:right-6 transition-all"></span>
                    </button>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        props: ['discount', 'lang'],
        data() {
            return {
                discountCode: '',
                showDiscountBox: false,
                validation: {
                    discount: {
                        state: null,
                        message: ''
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            applyDiscount()
            {
                if(this.discountCode == "") {
                    this.validation.discount.state = true;
                    if(this.lang == 'it') {
                        this.validation.discount.message = 'Devi inserire un codice valido';
                    }else{
                        this.validation.discount.message = 'Your code is invalid';
                    }
                    return
                }

                axios.post('/api/cart/discount', {
                    code: this.discountCode
                })
                    .then(response => {

                        if(!response.data.success) {
                            if(this.lang == "it") {
                                this.validation.discount.message = 'Il codice inserito non è valido';
                            }else{
                                this.validation.discount.message = 'Your code is invalid';
                            }
                            this.validation.discount.state = true;
                        }else{
                            this.$eventHub.$emit('discount.applied');
                        }

                    })
            },
        },
        beforeDestroy() {

        },
    }
</script>
